const checkEmail = (rule, value, callback) => {
  const mailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (mailReg.test(value)) {
    callback();
  } else {
    callback(new Error('正しいメールアドレスを入力ください。'));
  }
};

const checkPassword = (rule, value, callback) => {
  const letterReg = /[a-zA-Z]/;
  const numberReg = /[0-9]/;

  if (letterReg.test(value) && numberReg.test(value) && value.length > 5) {
    callback();
  } else {
    callback(new Error('パスワードは英字と数字をどちらも含む6文字以上の半角英数記号でご設定ください。'));
  }
};

const checkUserName = (rule, value, callback) => {
  const letterReg = /[a-zA-Z]/;
  const numberReg = /[0-9]/;

  if (letterReg.test(value) && numberReg.test(value) && value.length > 5) {
    callback();
  } else {
    callback(new Error('ログインIDは半角英数字を入力してください。'));
  }
};

const shouldShowDetailList = (status) => ['1', '2', '3'].indexOf(status) > -1;

/**
 * 郵便番号
 * @param {*} s
 */
 export function isZipCode (s) {
  return /^[0-9]{3}[0-9]{4}$/.test(s)
}

/**
 * kana
 * @param {*} s
 */
export function isKana (s) {
  return /^[\u30A0-\u30FF]+$/.test(s)
}

/**
 * 日本手机号码
 * @param {*} s
 */
export function isMobile (s) {
  // return /^1[0-9]{10}$/.test(s)
  return /0[789]0-?[0-9]{4}-?[0-9]{4}$/.test(s)
}

/**
 * 日本固定电话
 * @param {*} s
 */
export function isFixedPhone (s) {
  return /^0[0-9]{9}$/.test(s)
}

/**
 * 日本传真
 * @param {*} s
 */
export function isFax (s) {
  return /^0[0-9]{9}$/.test(s)
}


/**
 * 日付
 * @param {*} s
 */
export function isDateYYYYMMDD(dateStr) {

  const minYear = 1900          // 最小年
  const maxYear = 2025          // 最大年

  // 1. 基本フォーマットチェック
  if (!/^\d{8}$/.test(dateStr)) {
    return false
  }
  
  const year = parseInt(dateStr.substring(0, 4))
  const month = parseInt(dateStr.substring(4, 6))
  const day = parseInt(dateStr.substring(6, 8))
  
  // 2. 年の範囲チェック
  if (year < minYear || year > maxYear) {
      return false
  }
  
  // 3. 月チェック
  if (month < 1 || month > 12) {
    return false
  }
  
  // 4. 日付存在チェック
  const date = new Date(year, month - 1, day)
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return false
  }
  
  // 5. 未来日チェック（オプション）
  const today = new Date()
  today.setHours(0, 0, 0, 0) // 時間部分をリセット
  
  if (date > today) {
    return false
  }
  
  return true
}

export default {
  checkEmail,
  checkPassword,
  checkUserName,
  shouldShowDetailList,
  isDateYYYYMMDD,
};
